import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import {
  CheckTooltipsItem, CheckTooltipsListFormInput,
  createEmptyCheckTooltipsListFormInput
} from '@rpe/registro-personas-empresas-lib';

import { ROUTE_ANIMATIONS_ELEMENTS } from '../../../../core/core.module';
import { State } from '../../../vista-usuario/vista-usuario.state';
import { entityRPESubActividadesAddRequest } from '../../entity-rpe-sub-actividades/rpe-sub-actividades.actions';
import { createRPESubActividad, RPESubActividad } from '../../entity-rpe-sub-actividades/rpe-sub-actividades.model';
import { RegistroActividadAcreditacionFormInput } from '../registro-actividad-acreditacion.model';

@Component({
  selector: 'rpe-registro-actividad-acreditacion-form',
  templateUrl: './registro-actividad-acreditacion-form.component.html',
  styleUrls: ['./registro-actividad-acreditacion-form.component.scss']
})
export class RegistroActividadAcreditacionFormComponent implements OnInit {
  @Input()
  set formInput(auxFormInput: RegistroActividadAcreditacionFormInput) {
    this._formInput = auxFormInput;
    this.formInputCheckTooltipsList = createEmptyCheckTooltipsListFormInput();
    for (const ge of auxFormInput.listaRegActAcr) {
      // De estas subactividades mostradas hay que bloquear de acuerdo a la siguiente condición:
      // • Campo y Maquinaria: Bloquear si la empresa no tiene registrada una actividad con el tipo de actividad de producción.
      // • Plantas de procesamiento: Bloquear si la empresa no tiene registrada una actividad con el tipo de actividad de procesamiento.
      // • Laboratorio: Bloquear si la empresa no tiene registrada una actividad con el tipo de actividad de laboratorio

      //Todo falta validar
      this.formInputCheckTooltipsList.elementosCheck.push({
        id: ge.tipoSubActividad.id,
        nombre: ge.tipoSubActividad.nombre,
        selected: ge.seleccionada,
        disabled: !ge.poseeActividad,
        tooltips: !ge.poseeActividad
          ? `Para seleccionar la etapa ${ge.tipoSubActividad.nombre} debe registrar la actividad ${ge.actividadDependencia}`
          : null
      });
      const gEspecies = ge.listaEspeciesDelTipo.filter(e => e.selected == true);
      if (gEspecies){        
        this.registroActividadAcreditacionFormGroup.get(this.especiesArray[ge.tipoSubActividad.id - 1]).setValue(gEspecies.map(ge => ge.id));        
      };
    }
  }
  get formInput(): RegistroActividadAcreditacionFormInput {
    return this._formInput;
  }

  listado: CheckTooltipsItem[];

  formValid: boolean = false;
  _formInput: RegistroActividadAcreditacionFormInput = null;
  formInputCheckTooltipsList: CheckTooltipsListFormInput = null;
  registroActividadAcreditacionFormGroup: FormGroup = this.fb.group({
    especies1: [,[]],
    especies2: [,[]],
    especies3: [,[]],
    especies4: [,[]],
    especies5: [,[]]
  });

  especiesArray = ['especies1', 'especies2', 'especies3', 'especies4','especies5'];
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;

  trackByFn(item: any) {
    return item.id;
  }

  constructor(private fb: FormBuilder, private store: Store<State>) {}

  ngOnInit(): void {    
  }

  ngOnDestroy(): void {}

  reset(): void {}

  onEspecieChange(event: any) {}

  formStatusChanges(status: string) {
    this.formValid = status === 'VALID';
  }

  formValueChanges(c: any) {
    this.listado = c;
  }

  obtenerEspecies(idTipoSubAct: number) {
    return this.formInput.listaRegActAcr.find(
      (e) => e.tipoSubActividad.id == idTipoSubAct
    ).listaEspeciesDelTipo;
  }

  onShowErrors(): void {
    this.registroActividadAcreditacionFormGroup.markAllAsTouched();
  }

  onCancel(){}

  isValid(): boolean{
    return true
  }

  onGuardar(){
    if (this.isValid()){
      const actividad_id = this.formInput.actividad_id;
      let subActividades: RPESubActividad[] = [];
      this.listado.forEach(item  => {
        const gps = this.registroActividadAcreditacionFormGroup.get('especies' + item.id).value;        
        subActividades.push(createRPESubActividad({
          actividad_id: actividad_id,
          tipo_subactividad_id: item.id,
          especies_id: gps
        }));        
      });
      // RPE SUBACTIVIDADES
      this.store.dispatch(entityRPESubActividadesAddRequest({
        item: subActividades
      }))
    }
  }
}
